import { render, staticRenderFns } from "./recent_doc_sign_again.vue?vue&type=template&id=781ad2d8&"
import script from "./recent_doc_sign_again.vue?vue&type=script&lang=js&"
export * from "./recent_doc_sign_again.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports